import React from "react";
import Header from '../navigation/header';
import Contact from "./contact";
import Footer from '../navigation/footer';


export default function ContactPage(){
    return(
        <>
            <Header />
            <Contact />
            <Footer />
        </>
    )
}